<div class="voucher__card">
    <div class="left__side">
        <div class="name">{{data()?.name}}</div>
        @if(data()?.periodeEnd) {
            <div class="end__date">{{'voucherCard.until' | translate}} {{data()?.periodeEnd}}</div>
        }
    </div>
    <div class="right__side">
        <img src="https://www.telkomsel.com/api/assets/images/2023-07-13/promo/64afd3a95b6d6.viu-paket-nonton-hemat-JUL23--BTL1.jpg" alt="">
    </div>
</div>